import { render, staticRenderFns } from "./overlayModal.vue?vue&type=template&id=1261983e&"
import script from "./overlayModal.vue?vue&type=script&lang=js&"
export * from "./overlayModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports